var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNavigateBefore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    viewBox: "0 96 960 960",
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M560.41 802.153 333.847 575.59 560.41 348.77l35.794 35.794L405.435 575.59l190.769 190.769-35.794 35.794Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavigateBefore);
export default __webpack_public_path__ + "static/media/icon-navigate-before.5501e31f9da41f6f498d9dac4bdcb882.svg";
export { ForwardRef as ReactComponent };